import * as React from "react";

export const MemberShip = (props: any) => {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={32} height={32} rx={16} fill="#F7CB15" />
      <path
        d="M10.857 8a.569.569 0 00-.511.34L8.06 13.263a.654.654 0 00.068.664l7.428 9.846A.556.556 0 0016 24a.556.556 0 00.444-.227l7.428-9.846a.654.654 0 00.068-.664L21.654 8.34a.569.569 0 00-.511-.34H10.857zm-1.361 4.923l1.714-3.692h2.344l-.857 3.692H9.496zm.276 1.23h2.95l1.845 6.356-4.795-6.355zm4.148 0h4.16L16 21.322l-2.08-7.167zm5.357 0h2.951l-4.795 6.356 1.844-6.355zm3.227-1.23h-3.2l-.858-3.692h2.344l1.714 3.692zm-4.379 0h-4.25l.857-3.692h2.536l.857 3.692z"
        fill="#fff"
      />
    </svg>
  );
};
